<template>
  <div>
    <nav style="display: flex;">
      <ul class="pagination" style="margin-top: 24px;">
        <li class="page-item" :class="{ disabled: current === 1 }">
          <a class="page-link" style="cursor: default" @click="onClickPrev">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li
          v-for="page in pagesInRange"
          :key="page"
          class="page-item"
          :class="{ active: page === current }"
        >
          <a
            class="page-link"
            style="cursor: default"
            @click="onClickSpecific(page)"
            >{{ page }}</a
          >
        </li>
        <li class="page-item" :class="{ disabled: current === total }">
          <a class="page-link" style="cursor: default" @click="onClickNext">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
      <div class="form-group" style="margin-left: 10px;">
        <label>{{ $t('items_per_page') }}</label>
        <select
          v-model="size"
          class="form-control input-sm"
          @change="onChangePageSize"
        >
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="30">30</option>
        </select>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    current: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      size: 10
    }
  },
  mounted() {
    this.size = this.pageSize
  },
  methods: {
    onClickSpecific(page) {
      this.$emit('change', page)
    },
    onClickNext() {
      if (this.current === this.total) return

      if (this.current < this.total) this.$emit('change', this.current + 1)
    },
    onClickPrev() {
      if (this.current === 1) return

      if (this.current > 1) this.$emit('change', this.current - 1)
    },
    onChangePageSize() {
      this.$emit('pageSizeChange', this.size)
      this.$emit('change', 1)
    }
  },
  computed: {
    pivot() {
      if (this.current < 4) return this.current - 1

      if (this.current === this.total) return 4

      if (this.current + 2 > this.total)
        return this.total + 3 - (this.current + 1)

      return 2
    },
    pagesInRange() {
      const pagesInMiddleOfRange = Array.from(
        { length: 5 },
        (v, i) => i + (this.current - this.pivot)
      )

      return pagesInMiddleOfRange.filter(
        page => !(page > this.total || page < 1)
      )
    }
  }
}
</script>
